@if (!isSelfServiceSpCatalog) {
  @if (!isIdle) {
    <!-- FOR PAGES THAT NEEDS STATIC ELEMENTS -->
    <div>
      <div class="flex flex-col h-screen">
        @if (appCanBeDisplayed && !fullPageScreen) {
          <div id="top-content">
            @if (analyzerBanner) {
              <bt-analyzer-banner [config]="analyzerBanner"></bt-analyzer-banner>
            }
            @if (chip) {
              <bt-chips [config]="chip"></bt-chips>
            }
            <bt-banner></bt-banner>
          </div>
        }
        <div class="flex min-h-0 flex-1">
          @if (appCanBeDisplayed && !fullPageScreen) {
            <bt-sidebarnavigation></bt-sidebarnavigation>
          }
          <main class="flex flex-col z-1" id="main-wrapper" style="width: 100%;">
            @if (appCanBeDisplayed && !fullPageScreen) {
              <bt-topnavigation id="bt-main-topnavigation"
              [hidden]="hideTopNagivation"></bt-topnavigation>
            }
            <bt-panel-navigation
            [hidden]="fullPageScreen || hidePanelNagivation || !appCanBeDisplayed"></bt-panel-navigation>
            @if (appCanBeDisplayed) {
              <div class="min-h-0 block flex-1 relative z-0">
                <router-outlet></router-outlet>
                <router-outlet name="modal"></router-outlet>
              </div>
            }
            @if (!appCanBeDisplayed) {
              <bt-loader class="flex items-center justify-center h-screen" [light]="true"
              ></bt-loader>
            }
          </main>
        </div>
        @if (isInPreviewUser && previewUserEmail && !fullPageScreen) {
          <div id="bottom-content"
            class="w-full h-30px flex flex-none items-center justify-center bg-yellow-minion text-black text-16 font-medium font-display z-50"
            >
            <p>Admin Preview Mode - {{previewUserEmail}}</p>
          </div>
        }
      </div>
      @if (!fullPageScreen  || (fullPageScreen && isPublicPage)) {
        <div id="modal-no-internet-connection" class="group relative z-50 h-0px show hidden" role="dialog"
          aria-labelledby="share-dialog-title" aria-modal="true" tabindex="-1">
          <div
            class="mt-4px top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 fixed w-112.5 bg-white rounded-md shadow-alt transition-all duration-200 opacity-0 invisible group-[.show]:opacity-100 group-[.show]:visible z-10">
            <div>
              <div class="px-16px py-12px rounded-t-md">
                <p id="share-dialog-title"
                  class="font-display font-medium text-28 text-black mb-0px leading-8">
                {{connectionStatus}}</p>
              </div>
              <div class="px-16px py-16px">
                <div class="mt-2px px-7px py-3px mb-16px">
                  <p class="text-sm text-gray-500" [innerHTML]="connectionStatusMessage"></p>
                </div>
                @if (isOffline) {
                  <div class="items-center px-4px py-3px">
                    <a href="#" class="btn-primary" (click)="reload()">
                      Refresh application
                    </a>
                  </div>
                }
              </div>
            </div>
          </div>
          <div data-toggle="modal" data-target="#modal-no-internet-connection"
            class="fixed inset-0 bg-black/50 transition-all duration-200 opacity-0 invisible group-[.show]:opacity-100 group-[.show]:visible z-0">
          </div>
        </div>
          @if (loadingModal) {
            <bt-modal [config]="loadingModal"></bt-modal>
          }

          @if (showQualifyingQuestion) {
            <bt-qualifying-question (closeModal)="this.showQualifyingQuestion = false"></bt-qualifying-question>
          }
        }
      </div>
    }
    <!-- IDLE COMPONENT -->
    @if (isIdle) {
      <bt-idle></bt-idle>
    }
  }

  @if (isSelfServiceSpCatalog) {
    <div class="h-screen">
      <router-outlet></router-outlet>
    </div>
  }

  <p id="hidden-rendering-purpose" class="hidden">THIS IS HERE HIDDEN FOR
  RENDERING PURPOSES</p>
